export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';

export const dialogsList = {
    newForm: 'newForm',
    deleteForm: 'deleteForm',
    copyForm: 'copyForm',
    saveForm: 'saveForm',
    editForm: 'editForm',
    editWarning: 'editWarning'
};
